import React from "react";
import { FolderAddFilled } from "@ant-design/icons";

import Button from "components/buttons/Button";
import ManageProductModal from "components/Modals/ManageProductModal";
import Fetch from "components/Fetch";

/**
 *
 * @returns button with modal
 */

export default function App(props) {
  const [visible, setVisible] = React.useState(false);
  const [data, setData] = React.useState(false);
  const showModal = () => {
    setVisible(true);
  };

  React.useEffect(() => {
    Fetch.get("/products", (res) => {
      if (res) {
        setData(res);
      }
    });
  }, []);

  return (
    <>
      <Button style={{ marginLeft: 14 }} onClick={showModal}>
        <FolderAddFilled style={{ fontSize: 26 }} />
      </Button>
      {data && (
        <ManageProductModal
          {...props}
          reload={() => {}}
          visible={visible}
          setVisible={setVisible}
          data={data}
        />
      )}
    </>
  );
}
